import {whitelabelSettingsKey} from '@/api/queries/keys/subdomainKeys';
import WhitelabelRepository from '@/api/repositories/WhitelabelRepository';
import {useQuery} from '@tanstack/vue-query';
import {type Ref} from 'vue';

export function useWhitelabelSettingsQuery(subdomain: Ref<string | null>) {
    return useQuery({
        queryKey: whitelabelSettingsKey(subdomain),
        queryFn: async () => {
            if (!subdomain.value) {
                return null;
            }
            return WhitelabelRepository().read(subdomain.value);
        },
        staleTime: 24 * 60 * 60 * 1000, // 24 hours
        meta: {
            persist: true,
        },
    });
}
